import styled from 'styled-components';
import { IContainer } from '.';

export const Wrapper = styled.div<Pick<IContainer, 'width'>>`
    margin: 0 auto;
    width: 100%;
    max-width: ${p => (p.width ? p.width + 'px' : '1140px')};
`;
